
<script>
export default {
  props: {
    label: {
      type: [String, Number],
      required: true
    },
    obrigatorio: {
      type: Boolean,
      default: false
    },
    Indice: {
      type: Number,
      required: false,
      default: null
    }
  }
}
</script>

<template>
  <div class="mb-1">
    <b v-show="Indice">{{ Indice }})&nbsp;</b>
    {{ label }}
    <span v-show="obrigatorio" class="color-error">&nbsp;*</span>
  </div>
</template>

<style scoped lang="scss">
@import '@/scss/_colors.scss';
@import '@/scss/_utilities.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/Label/Label.vue